module.exports = __webpack_public_path__ + "img/VetoSans-Light.bb186ba6.svg";